<template>
  <div class="c--about-us_contents tw-container tw-mx-auto">
    <div class="about-us-contents tw-grid tw-gap-5 sm:tw-gap-7.5 lg:tw-gap-x-7.5 lg:tw-gap-y-10">
      <div v-for="(content, index) in contents" :key="`about-us-content-item-${index}`" :class="itemClasses">
        <div
          :class="[
            itemTextColumnClasses,
            { 'xl:tw-col-start-2': !content.reverse, 'lg:tw-col-start-6 xl:tw-col-start-8': content.reverse },
          ]"
        >
          <h2 class="typography-h3 md:typography-page-title tw-mb-0">{{ content.title }}</h2>
          <p class="tw-text-15-21 tw-text-secondary tw-mt-2.5 tw-mb-5" v-html="content.content" />

          <nuxt-link
            v-if="getLearnMoreLink(content.key)"
            @click.native="
              sendEventHandler({
                text: $t('scenes.about.us.learn-more-button-title'),
                url: getLearnMoreLink(content.key),
              })
            "
            tag="button"
            :to="getLearnMoreLink(content.key)"
            type="button"
            class="learn-more-btn call-to-action dark no-outline btn-primary-hv tw-w-full md:tw-w-[160px] tw-min-h-[44px]"
          >
            {{ $t('scenes.about.us.learn-more-button-title') }}
          </nuxt-link>
        </div>
        <div
          :class="[
            itemImageColumnClasses,
            { 'lg:tw-col-start-6 xl:tw-col-start-7': !content.reverse, 'xl:tw-col-start-2': content.reverse },
          ]"
        >
          <nuxt-img
            :src="content.img"
            :alt="content.title"
            width="445"
            height="455"
            loading="lazy"
            class="tw-max-w-full tw-h-auto"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'about-us-contents',

    props: ['contents'],

    data() {
      return {
        itemClasses: [
          'about-us-content-item tw-grid tw-gap-5 tw-items-center',
          'tw-grid-flow-row',
          'lg:tw-grid-flow-col lg:tw-grid-cols-12 lg:tw-grid-cols-10 xl:tw-grid-cols-12',
        ],
        itemTextColumnClasses: [
          'about-us-content-item-text tw-order-2 lg:tw-col-span-5 xl:tw-col-span-4 lg:tw-order-1 tw-text-center lg:tw-custom-text-align-inherit',
        ],
        itemImageColumnClasses: [
          'about-us-content-item-image tw-order-1 lg:tw-col-span-5 lg:tw-order-2 tw-text-center',
        ],
      }
    },

    methods: {
      getLearnMoreLink(key) {
        const links = ['about-us-impact', 'about-us-values']

        if (links.includes(key)) {
          let aboutUsLink = key.replace('about-us-', '')
          if (aboutUsLink === 'values') {
            aboutUsLink = 'our-values'
          }

          return this.localePath(`/about-us/${aboutUsLink}`)
        }

        return false
      },
      sendEventHandler(payload) {
        this.$utils.sendEvent('ctaClick', payload)
      },
    },
  }
</script>
